import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSauceBottle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			className: "plan2plate-icon",
			x: 7.23,
			y: 9.14,
			width: 9.55,
			height: 13.36,
			rx: 1.91
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "plan2plate-icon",
			x: 9.14,
			y: 5.32,
			width: 5.73,
			height: 3.82
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "plan2plate-icon",
			points: "13.91 5.32 10.09 5.32 11.04 1.5 12.96 1.5 13.91 5.32"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 10.09,
			y1: 15.82,
			x2: 13.91,
			y2: 15.82
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "plan2plate-icon",
			x: 7.23,
			y: 12.95,
			width: 9.55,
			height: 5.73
		})
	]
});
const ForwardRef = forwardRef(SvgSauceBottle);
export default ForwardRef;
